<template>
  <div class="configurationErrorDiv">
    <v-container>
      <v-flex class="text-xs-center">
        <p>Unable to retrieve BedBoard configuration.  Press the <b>Retry</b> button below to attempt to retrieve configuration again.</p>
        <p>If this continues, please contact support with this messsage.</p>
      </v-flex>
      <v-flex class="text-xs-center">
        <v-btn class="ntstAppButton" @click.stop="retry() ">
          Retry
        </v-btn>
        <v-btn class="ntstAppButton" @click.stop="logout() ">
          Logout
        </v-btn>
      </v-flex>
    </v-container>
  </div>
</template>


<script lang="js">
export default {
  name: 'ConfigurationError',
  data() {
    return {
    };
  },
  props: {
    onLogout: Function,
    onRetry: Function,
  },
  components: {
  },
  computed: {
  },
  methods: {
    logout() {
      this.onLogout();
    },
    retry() {
      this.onRetry();
    },
  }
};
</script>


<style lang="scss">
.configurationErrorDiv {
  background-color: #ffffff;
}
</style>
